var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2116_1147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8 18H6C4.34 18 2.9252 17.4148 1.7556 16.2444C0.586001 15.074 0.000800819 13.6592 8.19113e-07 12C-0.000799181 10.3408 0.584401 8.926 1.7556 7.7556C2.9268 6.5852 4.3416 6 6 6H10.8V8.4H6C5 8.4 4.15 8.75 3.45 9.45C2.75 10.15 2.4 11 2.4 12C2.4 13 2.75 13.85 3.45 14.55C4.15 15.25 5 15.6 6 15.6H10.8V18ZM7.2 13.2V10.8H16.8V13.2H7.2ZM13.2 18V15.6H18C19 15.6 19.85 15.25 20.55 14.55C21.25 13.85 21.6 13 21.6 12C21.6 11 21.25 10.15 20.55 9.45C19.85 8.75 19 8.4 18 8.4H13.2V6H18C19.66 6 21.0752 6.5852 22.2456 7.7556C23.416 8.926 24.0008 10.3408 24 12C23.9992 13.6592 23.414 15.0744 22.2444 16.2456C21.0748 17.4168 19.66 18.0016 18 18H13.2Z",
    fill: "#1877F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2116_1147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.0c7dbe231d628fd5063545032eab8aea.svg";
export { ForwardRef as ReactComponent };